(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["agatha-brand-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  for (const menu of document.querySelectorAll('.ag-mobile-menu[open]')) {
    if (!menu.contains(event.target) || event.target.closest('.ag-mobile-menu a')) menu.open = false;
  }
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  for (const menu of document.querySelectorAll('.ag-mobile-menu[open]')) {
    menu.open = false;
    menu.querySelector('summary').focus();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agatha-cro"] && !Shopify.designMode) return;
  try {
    
function initializeAgathaMobile(container = document) {
  const roots = container.matches?.('.agv2') ? [container] : container.querySelectorAll('.agv2');
  for (const root of roots) {
    if (root.dataset.agvEnhanced) continue;
    root.dataset.agvEnhanced = 'true';
    const bar = root.querySelector('.agv-mobile-bar');
    const heroAction = root.querySelector('.agv-hero .agv-button');
    const purchaseActions = [...root.querySelectorAll('[data-agv-purchase]')].filter((action) => !bar?.contains(action));
    const visibleActions = new Set();
    const dialog = root.querySelector('.agv-image-dialog');
    let heroPassed = false;
    let opener = null;
    const updateBar = () => {
      if (bar) bar.hidden = !heroPassed || visibleActions.size > 0 || Boolean(dialog?.open);
    };
    let observer;
    if ('IntersectionObserver' in window && heroAction && purchaseActions.length) {
      observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.target === heroAction) heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          if (entry.isIntersecting && entry.intersectionRatio > 0) visibleActions.add(entry.target);
          else visibleActions.delete(entry.target);
        }
        updateBar();
      }, { threshold: 0 });
      observer.observe(heroAction);
      for (const action of purchaseActions) observer.observe(action);
    }
    root.addEventListener('click', (event) => {
      const sample = event.target.closest('.agv-sample-open');
      if (sample && dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        opener = sample;
        dialog.classList.remove('is-zoomed');
        dialog.querySelector('[data-agv-dialog-image]').src = sample.dataset.agvFull;
        dialog.querySelector('[data-agv-dialog-image]').alt = sample.dataset.agvCaption;
        dialog.querySelector('[data-agv-dialog-title]').textContent = sample.dataset.agvCaption;
        const zoom = dialog.querySelector('[data-agv-zoom]');
        zoom.setAttribute('aria-pressed', 'false');
        zoom.textContent = zoom.dataset.zoomIn;
        dialog.showModal();
        const viewer = dialog.querySelector('.agv-dialog-body');
        viewer.scrollTop = 0;
        viewer.scrollLeft = 0;
        updateBar();
      }
      if (event.target.closest('[data-agv-close]')) dialog?.close();
      const zoom = event.target.closest('[data-agv-zoom]');
      if (zoom && dialog) {
        const enlarged = dialog.classList.toggle('is-zoomed');
        zoom.setAttribute('aria-pressed', String(enlarged));
        zoom.textContent = enlarged ? zoom.dataset.zoomFit : zoom.dataset.zoomIn;
      }
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    });
    dialog?.addEventListener('close', () => {
      updateBar();
      opener?.focus({ preventScroll: true });
    });
    root.agvCleanup = () => observer?.disconnect();
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeAgathaMobile(), { once: true });
} else {
  initializeAgathaMobile();
}
document.addEventListener('shopify:section:load', (event) => initializeAgathaMobile(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  for (const root of event.target.querySelectorAll('.agv2')) root.agvCleanup?.();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["agatha-library"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('.agl').forEach(root => {
      const sticky = root.querySelector('.agl-sticky');
      if (!sticky || sticky.dataset.ready) return;
      sticky.dataset.ready = 'true';
      const targets = [...root.querySelectorAll('[data-agl-buy]')];
      const visible = new Set();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
        sticky.hidden = visible.size > 0;
      }, { threshold: 0.15 });
      targets.forEach(target => observer.observe(target));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
